module.exports = __webpack_public_path__ + "static/mobile-app-ffc1d074c2f32db92a693b3cbade001b.png";